import type { FullSubEvent } from '@fastnorth/timer-api';
import type { ResponseWithType, FullSubEventResponse } from './types';

const subEventResponse = ({ data }: ResponseWithType<FullSubEvent>): FullSubEventResponse => {
  return {
    ...data,
    __typename: 'FullSubEvent',
  };
};

export default subEventResponse;
